import { useEffect, useRef } from 'react';
import { useStore } from '../store/useStore';
import type { Resource } from '../types';

export const useGameLoop = () => {
    const tick = useStore((state) => state.tick);
    const setMarketPrice = useStore((state) => state.setMarketPrice);
    const market = useStore((state) => state.market);
    const processMarketSim = useStore((state) => state.processMarketSim);

    // Ref to track time for market updates (60s)
    const marketTimer = useRef(0);

    useEffect(() => {
        const interval = setInterval(() => {
            // 1. Save / General tick
            tick(1000);

            // 2. Process active listings simulation
            processMarketSim();

            // 3. Market Price Updates (Every 60s)
            marketTimer.current += 1000;
            if (marketTimer.current >= 60000) {
                marketTimer.current = 0;

                Object.values(market).forEach((item) => {
                    if (item.id === 'gold') return;

                    // Random fluctuation +/- volatility
                    // Ensure integer math
                    const changeRange = Math.max(1, Math.floor(item.basePrice * item.volatility));
                    const change = Math.floor((Math.random() - 0.5) * 2 * changeRange); // -changeRange to +changeRange

                    let newPrice = Math.floor(item.currentPrice + change);

                    // Soft boundaries
                    const deviation = newPrice - item.basePrice;
                    if (Math.abs(deviation) > item.basePrice * 0.5) {
                        // Pull back 10%
                        newPrice -= Math.round(deviation * 0.1);
                    }

                    // Hard limits
                    if (newPrice < 1) newPrice = 1;

                    setMarketPrice(item.id, Math.floor(newPrice));
                });
            }

        }, 1000); // 1 second tick

        return () => clearInterval(interval);
    }, [tick, setMarketPrice, market, processMarketSim]);
};
